import React from "react";
import { Trash2 } from "lucide-react";
import ItemImage from "./ItemImage";
import QtyStepper from "./QtyStepper";
import { formatMoney, useCart } from "../../context/CartContext";

export default function CartLineItem({ line }) {
  const { increment, decrement, removeItem } = useCart();

  return (
    <li className="flex gap-3 py-3">
      <ItemImage urls={line.image_urls} alt={line.description} className="h-14 w-14 flex-none rounded-lg border border-gray-100" />
      <div className="min-w-0 flex-1">
        <div className="flex items-start justify-between gap-2">
          <div className="min-w-0">
            <p className="line-clamp-2 text-sm font-medium text-gray-900">{line.description}</p>
            {line.variationLabel && <p className="text-xs text-gray-500">{line.variationLabel}</p>}
          </div>
          <button type="button" onClick={() => removeItem(line.key)} className="flex-none rounded p-1 text-gray-400 hover:bg-gray-100 hover:text-red-600" aria-label={`Remove ${line.description}${line.variationLabel ? ` (${line.variationLabel})` : ""}`}>
            <Trash2 className="h-4 w-4" />
          </button>
        </div>
        <div className="mt-2 flex items-center justify-between">
          <QtyStepper size="sm" qty={line.qty} label={line.variationLabel ? `${line.description} (${line.variationLabel})` : line.description} onDecrement={() => decrement(line.key)} onIncrement={() => increment(line.key)} />
          <div className="text-right">
            <p className="text-sm font-semibold tabular-nums text-gray-900">{formatMoney(line.priceCents * line.qty)}</p>
            {line.qty > 1 && <p className="text-xs text-gray-400">{formatMoney(line.priceCents)} each</p>}
          </div>
        </div>
      </div>
    </li>
  );
}
